export default "__VITE_ASSET__CTV9oEYU__"